var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Banners","storeName":"Banners","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/app_ads","breadcrumbs":[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/banners'
      },
      {
        text: 'Banners',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"banner_picture",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[(item.banner_picture)?_c('v-list-item-avatar',{staticClass:"banner"},[_c('img',{attrs:{"src":item.banner_picture,"alt":""}})]):_vm._e()],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }